import React, { useRef } from 'react'
import cx from 'classnames'
import logger from 'logger'

import { AspectContainer } from 'components/layout'

import MP4 from './components/MP4/MP4'
import YoutubePlayer from './components/YoutubePlayer/YoutubePlayer'


export type VideoProps = {
  className?: string
  videoClassName?: string
  type: 'mp4' | 'youtube'
  aspect?: number
  url: string
  preview?: string
  autoplay?: boolean
  muted?: boolean
  loop?: boolean
  controls?: boolean
  onPlay?: () => void
}

const Video: React.FunctionComponent<VideoProps> = (props) => {
  const { className, videoClassName, type, aspect = 100 / 56.25, ...rest } = props

  const loggerRef = useRef(false)

  const Component = ({
    'mp4': MP4,
    'youtube': YoutubePlayer,
  }[type?.toLowerCase()]) // if it passed from backend it may be in uppercase

  if (Component) {
    return (
      <AspectContainer className={cx(className, 'bg-black')} aspect={aspect}>
        {
          React.createElement(Component, { ...rest, className: videoClassName })
        }
      </AspectContainer>
    )
  }

  if (!loggerRef.current) {
    loggerRef.current = true
    logger.error('Video type is not recognized', {
      extra: {
        props,
      },
    })
  }

  return null
}


export default Video
